import * as actionTypes from '../actions/types';
const { StudentUpdatesState } = require('../initial.state');

export const StudentUpdatesReducer = (state = new StudentUpdatesState(), { type, response }) => {
  switch (type) {
    case actionTypes.GET_ALL_STUDENT_UPDATES:
      return { ...state, updates: response.data };
    case actionTypes.GET_STUDENT_UPDATE_BY_UPDATES_TYPE:
      return { ...state, [response.updateType]: response.data };
    default:
      return state;
  }
};
